// extracted by mini-css-extract-plugin
export default {"inputWrapper":"tldrEdit_inputWrapper__A-nJ3","inputInnerWrap":"tldrEdit_inputInnerWrap__Zb0dI","danger":"tldrEdit_danger__9xpo9","buttonsWrapper":"tldrEdit_buttonsWrapper__-qkm0"};